import { createRouter, ErrorComponentProps } from '@tanstack/react-router';
import { QueryClient } from '@tanstack/react-query';
import { IRouterContext } from '@my-pages/routing/types';
import useApplicationStore from '@my-pages/stores/useApplicationStore';
import DefaultErrorComponent from '@my-pages/routing/components/DefaultErrorComponent.tsx';
import FullScreenLoader from '@shared/components/FullScreenLoader.tsx';
import { routeTree } from '@my-pages/routeTree.gen.ts';

export const createAppRouter = (queryClient: QueryClient) => {
    const routerContext: IRouterContext = {
        queryClient: queryClient,
        applicationStore: useApplicationStore,
    };
    return createRouter({
        context: routerContext,
        defaultErrorComponent: ({ error, info, reset }: ErrorComponentProps) => {
            return (
                <DefaultErrorComponent
                    error={error}
                    info={info}
                    reset={reset}
                />
            );
        },
        defaultPendingComponent: () => <FullScreenLoader />,
        defaultPreload: 'intent',
        defaultPreloadStaleTime: 0,
        routeTree: routeTree,
        scrollRestoration: true,
        scrollRestorationBehavior: 'smooth',
    });
};
